export const DAY_NAMES = [
  { en: "Sunday", th: "อาทิตย์" },
  { en: "Monday", th: "จันทร์" },
  { en: "Tuesday", th: "อังคาร" },
  { en: "Wednesday", th: "พุธ" },
  { en: "Thursday", th: "พฤหัสบดี" },
  { en: "Friday", th: "ศุกร์" },
  { en: "Saturday", th: "เสาร์" },
];
